import * as turf from '@turf/turf';

export function buildRiskDriverMeasurements(map, draw) {
  const coll = { type: 'FeatureCollection', features: [] };
  if (!draw) return coll;

  const all = draw.getAll().features || [];
  const points = all.filter(f => f?.geometry?.type === 'Point');
  const polygons = all.filter(f => !f?.properties?.lotPerimeter && (f?.geometry?.type === 'Polygon' || f?.geometry?.type === 'MultiPolygon'));

  const toTurfPoly = (geom) => {
    if (!geom) return null;
    if (geom.type === 'Polygon') return turf.polygon(geom.coordinates);
    if (geom.type === 'MultiPolygon') return turf.multiPolygon(geom.coordinates);
    return null;
  };

  const lineToBoundary = (pt, polyLike) => {
    const outline = turf.polygonToLine(polyLike);
    const snapped = turf.nearestPointOnLine(outline, pt);
    const dist = turf.distance(pt, snapped, { units: 'meters' });
    const ls = turf.lineString([pt.geometry.coordinates, snapped.geometry.coordinates]);
    return { line: ls, dist };
  };

  points.forEach((ptFeature) => {
    const pt = turf.point(ptFeature.geometry.coordinates);

    polygons.forEach((polyFeature, polyIdx) => {
      const basePoly = toTurfPoly(polyFeature.geometry);
      if (!basePoly) return;

      const { line, dist } = lineToBoundary(pt, basePoly);
      line.properties = {
        target: 'polygon',
        pointId: ptFeature.id,
        polyId: polyFeature.id,
        label: `Poly ${polyIdx + 1}`,
        distance: Math.round(dist),
        units: 'm',
      };

      coll.features.push(line);
    });
  });

  return coll;
}

export const purgeMeasurementLayers = (map) => {
  ['risk-lines', 'risk-lines-label'].forEach(id => {
    if (map.getLayer(id)) map.removeLayer(id);
  });
  if (map.getSource('risk-lines')) map.removeSource('risk-lines');
};

export const addNearestRiskLinesToLotPerimeter = (map, e) => {
  if (map.getLayer('nearest-asset-lot-line')) {
    map.removeLayer('nearest-asset-lot-line');
    map.removeLayer('nearest-asset-lot-line-label');
    map.removeSource('nearest-asset-lot-line');
  }
  
  const feature = e?.features?.[0];
  if (!map || (!feature?.properties?.assetContour && !feature?.properties?.isBuilding)) return;

  const lotPerimeter = map.getSource('line');
  if (!lotPerimeter) return;

  const line = turf.polygonToLine(feature);

  const points = [];
  const totalLength = turf.length(line) * 1000;
  for (let i = 0; i <= totalLength; i++) {
    points.push(turf.along(line, i / 1000));
  }

  const lotLines = lotPerimeter._data.features;

  let minDistance = Infinity;
  let nearestLine = null;

  points.forEach(pt => {
    lotLines.forEach(lotLine => {
      const snapped = turf.nearestPointOnLine(lotLine, pt);
      const dist = turf.distance(pt, snapped, { units: 'meters' });
      if (dist < minDistance) {
        minDistance = dist;
        nearestLine = turf.lineString([pt.geometry.coordinates, snapped.geometry.coordinates]);
        nearestLine.properties = {
          distance: Math.round(dist),
          units: 'm',
          label: 'Nearest perimeter',
        }
      }
    });
  });

  if (map.getLayer('nearest-asset-lot-line')) {
    map.removeLayer('nearest-asset-lot-line');
    map.removeLayer('nearest-asset-lot-line-label');
    map.removeSource('nearest-asset-lot-line');
  }

  map.addSource('nearest-asset-lot-line', {
    type: 'geojson',
    data: nearestLine,
  });

  map.addLayer({
    id: 'nearest-asset-lot-line',
    type: 'line',
    source: 'nearest-asset-lot-line',
    paint: {
      "line-color": "#0059ff",
      "line-width": 2,
      "line-dasharray": [2, 2],
    },
  });

  map.addLayer({
    id: 'nearest-asset-lot-line-label',
    type: 'symbol',
    source: 'nearest-asset-lot-line',
    layout: {
      "symbol-placement": "line",
      "text-field": ["format", ["get", "distance"], { "font-scale": 1 }, " m"],
      "text-size": 12,
      "text-offset": [0, -0.5],
    },
    paint: { "text-halo-color": "#fff", "text-halo-width": 1 },
  });
}